import {Component, ElementRef, HostBinding, Input, ViewEncapsulation} from '@angular/core';
import {trigger} from "@angular/animations";
import {Observable} from "rxjs";
import {TransitionHandler} from "./transition-handler";
import {fade, fadeOut} from "./modal.animations";

@Component({
    selector: 'db-modal-backdrop',
    encapsulation: ViewEncapsulation.None,
    template: '',
    styleUrls: ['./modal-backdrop.scss'],
    animations: [
        trigger('fade', fade)
    ],
    standalone: false
})
export class DbModalBackdropComponent {
  @HostBinding('@fade') @Input() animation;
  @HostBinding('class') @Input() backdropClass;

  constructor(
    private _elementRef: ElementRef,
    private _transitionHandler: TransitionHandler
  ) {}

  hide(): Observable<void> {
    return this._transitionHandler.createTransition(this._elementRef.nativeElement, fadeOut, this.animation);
  }
}
